import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import "./Setting.css";
import ProfilePage from "../Profile/Profile";
import Receipts from "../MyReceipts/Receipts";
import Usage from "../MyUsage/Usage";
// import SocialPage from "./SocialPage";

const menuItems = [
  { label: "Profile", Element: <ProfilePage /> },
  { label: "Receipts", Element: <Receipts /> },
  { label: "Usage", Element: <Usage /> },
  // { label: "Connected Apps", Element: <SocialPage /> },
];

const Setting: React.FC = () => {
  const [activeMenu, setActiveMenu] = useState<string>("Profile");

  return (
    <Grid item spacing={2} className="settingMainContainer">
      <Box className="settingHeader">
        <Typography variant="body1" className="showcaseTitle" gutterBottom>
          Settings
        </Typography>
      </Box>
      <Grid
        container
        spacing={2}
        className="settingContainer"
        direction={{ xs: "column", md: "row" }}
      >
        <Box className="settingMenu">
          {menuItems.map((item, index) => (
            <Box
              key={index}
              className={`settingMenuItem${
                activeMenu === item.label ? " active" : "nonActive"
              }`}
              onClick={() => setActiveMenu(item.label)}
            >
              <Typography variant="body1" className="menuLabel">
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>
        <Box className="settingContent">
          {menuItems.map(
            (item, index) =>
              activeMenu === item.label && (
                <Box key={index} className="settingContentItem">
                  {item.Element}
                </Box>
              )
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default Setting;
